import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APP_CONFIG } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class SsoService {


  constructor(private http: HttpClient) { }

  getSSOReferenceId(requestBody: any): Observable<any> {
    return this.http.post<any>(`${APP_CONFIG.API_BASE_URL}${APP_CONFIG.SSO_DROP_OFF}`, requestBody);
  }
}
